import { render, staticRenderFns } from "./hotelAdmin.vue?vue&type=template&id=1789631b&scoped=true"
import script from "./hotelAdmin.vue?vue&type=script&lang=js"
export * from "./hotelAdmin.vue?vue&type=script&lang=js"
import style0 from "./hotelAdmin.vue?vue&type=style&index=0&id=1789631b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1789631b",
  null
  
)

export default component.exports